import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { RxCross2 } from "react-icons/rx";
import "../Css/AddtoCart.css";
import { useCartContext } from '../context/addToCart';
import { FiMinus, FiPlus, FiShoppingBag, FiArrowRight } from 'react-icons/fi';
import { useCurrency } from '../services/locationService';

const AddtoCart = () => {
  const { cartValue, setCartCount, setCartValue } = useCartContext();
  const { format } = useCurrency();
  const [subTotal, setSubTotal] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    updateSubtotal(cartValue || []);
  }, [cartValue]);

  const removeCartData = (index) => {
    setCartValue((prevData) => {
      const updatedData = [...prevData];
      updatedData.splice(index, 1);
      addtoLocalStorage(updatedData);
      setCartCount(updatedData.length);
      return updatedData;
    });
  };

  const updateSubtotal = (data) => {
    const subTotalValue = data.reduce((total, item) => {
      return total + parseFloat(item.fixedPrice) * item.productQuantity;
    }, 0);
    setSubTotal(subTotalValue);
  };

  const addtoLocalStorage = (data) => {
    localStorage.setItem("cart", JSON.stringify(data));
  };

  const handleIncrement = (index) => {
    setCartValue((prevData) => {
      const updatedData = [...prevData];
      const price = parseFloat(updatedData[index].fixedPrice);
      updatedData[index].productQuantity = Number(updatedData[index].productQuantity) + 1;
      updatedData[index].productQuantityPrice = (updatedData[index].productQuantity * price).toString();
      addtoLocalStorage(updatedData);
      updateSubtotal(updatedData);
      return updatedData;
    });
  };

  const handleDecrement = (index) => {
    setCartValue((prevData) => {
      const updatedData = [...prevData];
      if (updatedData[index].productQuantity > 1) {
        const price = parseFloat(updatedData[index].fixedPrice);
        updatedData[index].productQuantity = Number(updatedData[index].productQuantity) - 1;
        updatedData[index].productQuantityPrice = (updatedData[index].productQuantity * price).toString();
        addtoLocalStorage(updatedData);
        updateSubtotal(updatedData);
      }
      return updatedData;
    });
  };

  // Helper function to close offcanvas safely and navigate
  const handleNavigate = (path) => {
    const offcanvasElement = document.getElementById('offcanvasRight');
    if (offcanvasElement && window.bootstrap) {
      const offcanvasInstance = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (offcanvasInstance) {
        offcanvasInstance.hide();
      }
    }

    // Clean up leftover backdrops if any exist
    const backdrop = document.querySelector('.offcanvas-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    // Navigate to specified path
    navigate(path);
  };

  return (
    <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
      <div className="offcanvas-header">
        <h5 id="offcanvasRightLabel">Shopping Cart</h5>
        <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        {cartValue && cartValue.length > 0 ? (
          <>
            <div className='Product-addedCart-Side-Bar'>
              {cartValue.map((elem, index) => (
                <div key={index} className='Product-addedCart-Side-details'>
                  <div className='Product-addedCart-Image-con'>
                    <div className='Product-addedCart-Image'>
                      <img src={elem.productImage} alt={elem.productName} />
                    </div>
                  </div>
                  <div className='Product-details-addedCart-price-name'>
                    <h2>{elem.productName}</h2>
                    {elem?.productSize == 0 ? null : (
                      <h3><span>Size : {elem.productSize}</span></h3>
                    )}
                    <h3><span>Color : {elem.productColor}</span></h3>
                    <h3><span>Price : </span>{format(elem.fixedPrice)}</h3>
                    <div className='Peoduct-Details-Section-1-Quantity-main-con'>
                      <div className='Product-details-Quantity-counter-material'>
                        <button onClick={() => handleDecrement(index)}>
                          <FiMinus />
                        </button>
                        <h3>{elem.productQuantity}</h3>
                        <button onClick={() => handleIncrement(index)}>
                          <FiPlus />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className='Product-details-addedCart-cancel-btn'>
                    <div className='Product-details-addedCart-cancel-btn-con' onClick={() => removeCartData(index)}>
                      <RxCross2 />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='Product-details-Addedcart-total-con'>
              <div className='Product-details-Addedcart-total'>
                <div className='Product-details-Addedcart-total-title'>
                  <h4>Subtotal:</h4>
                </div>
                <div className='Product-details-Addedcart-total-Amount'>
                  <h5>{format(subTotal)}</h5>
                </div>
              </div>
              <div className='Product-details-Addedcart-btn'>
                <div className='Product-details-Addedcart-btn-ViewCart'>
                  <button
                    type="button"
                    className="Product-details-Addedcart-checkout-link"
                    onClick={() => handleNavigate('/CheckOutPage')}
                  >
                    Checkout
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          /* Premium Custom Empty Cart Container */
          <div className="empty-cart-wrapper">
            <div className="empty-cart-glow"></div>
            
            {/* Animated Icon Ring */}
            <div className="empty-cart-icon-box">
              <div className="empty-cart-ring"></div>
              <FiShoppingBag className="empty-bag-icon" />
            </div>

            {/* Typography */}
            <h3 className="empty-cart-title">Your Cart is Empty</h3>
            <p className="empty-cart-subtitle">
              Looks like you haven't added anything to your cart yet. Discover our exclusive collection today.
            </p>

            {/* Primary Action Button */}
            <button
              type="button"
              className="empty-cart-btn-link empty-cart-btn"
              onClick={() => handleNavigate('/')}
            >
              <span>Start Shopping</span>
              <FiArrowRight className="btn-arrow-icon" />
            </button>

            {/* Quick Category Discovery Pills */}
            <div className="empty-cart-categories">
              <span>Popular Picks:</span>
              <div className="category-pills">
                <button type="button" onClick={() => handleNavigate('/accessories')}>Accessories</button>
                <button type="button" onClick={() => handleNavigate('/fragrance')}>Fragrance</button>
                <button type="button" onClick={() => handleNavigate('/apparel')}>Apparel</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddtoCart;